import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { HeroSection } from "./components/sections/HeroSection";
import { ProblemSection } from "./components/sections/ProblemSection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { SituationsSection } from "./components/sections/SituationsSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { StudyToolsSection } from "./components/sections/StudyToolsSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { CreatorSection } from "./components/sections/CreatorSection";
import { FaqSection } from "./components/sections/FaqSection";
import { FinalCtaSection } from "./components/sections/FinalCtaSection";
import { SiteFooter } from "./components/sections/SiteFooter";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="3rbzpsoyupgu6">
      <MetaPixel data-id="element-1" data-mp="6htjo98ovic" />
      <HeroSection data-id="element-2" data-mp="4wylxj0jajy" />
      <main data-id="element-3" data-mp="56ntiw8hdol">
        <ProblemSection data-id="element-4" data-mp="82jf0klzq9v" />
        <BeforeAfterSection data-id="element-5" data-mp="2zld0746gb58w" />
        <SituationsSection data-id="element-6" data-mp="2zm4wkh7vh708" />
        <VolumesSection data-id="element-7" data-mp="2zmwguvw0rib7" />
        <StudyToolsSection data-id="element-8" data-mp="33mou3lwcycmw" />
        <BonusesSection data-id="element-9" data-mp="33lwy49yumcw3" />
        <OfferSection data-id="element-10" data-mp="33nghwajpr62m" />
        <GuaranteeSection data-id="element-11" data-mp="33orik1hv3xpi" />
        <TestimonialsSection data-id="element-12" data-mp="38m1gy6n8bjph" />
        <CreatorSection data-id="element-13" data-mp="38kqb81a841vq" />
        <FaqSection data-id="element-14" data-mp="38kgkucl9nspi" />
        <FinalCtaSection data-id="element-15" data-mp="38o4ercumih4r" />
      </main>
      <SiteFooter data-id="element-16" data-mp="3dl4l7ovdxlwe" />
      <FloatingCta data-id="element-17" data-mp="3dlns8ajhypvn" />
      <PurchasePopup data-id="element-18" data-mp="3dm5zs3bm0qiv" />
    </div>;
}